import { ONE_DAY, ONE_HOUR, ONE_MINUTE, ONE_WEEK } from '@gem/services/date-service';

export const mapReminderToMinutes = (time: number, unit: string): string => {
  if (unit === 'minutes') {
    return String(time);
  }

  if (unit === 'hours') {
    return String((time * ONE_HOUR) / ONE_MINUTE);
  }

  if (unit === 'days') {
    return String((time * ONE_DAY) / ONE_MINUTE);
  }

  if (unit === 'weeks') {
    return String((time * ONE_WEEK) / ONE_MINUTE);
  }

  return '';
};
